
import React from 'react';

interface DoctorProfileCardProps {
    doctor: {
        name: string;
        specialisation: string;
        profile: string;
        treatments: { name: string }[];
    };
}

const DoctorProfileCard: React.FC<DoctorProfileCardProps> = ({ doctor }) => {
    return (
        <div className="bg-white p-5 rounded-xl shadow mb-6">
            <div className="flex items-center gap-4">
                <img
                    src={doctor.profile}
                    alt={doctor.name}
                    className="w-20 h-20 rounded-full object-cover border"
                />
                <div>
                    <h1 className="text-xl font-bold text-indigo-700">{doctor.name}</h1>
                    <p className="text-gray-600">{doctor.specialisation}</p>
                    <p className="text-gray-500 mt-1">
                        Treatments: {doctor.treatments?.map((t) => t.name).join(", ")}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DoctorProfileCard;
